/**
 * ambientacaoBuilder — Ambientações (Material Didático — vídeo de boas-vindas), BE módulo content.
 *
 * @since fase material-didático ambientacao (2026-07-16)
 */
import type { $Fetch } from 'ofetch';

import { HttpAmbientacaoGateway } from '@/infrastructure/http/HttpAmbientacaoGateway';
import {
  ListAmbientacoes, CreateAmbientacao, UpdateAmbientacao, ArquivarAmbientacao,
} from '@/application/usecase/AmbientacaoUseCaseImpl';

export function buildAmbientacaoSlice(httpClient: $Fetch) {
  const gateway = new HttpAmbientacaoGateway(httpClient);

  const useCases = {
    listAmbientacoes: new ListAmbientacoes(gateway),
    createAmbientacao: new CreateAmbientacao(gateway),
    updateAmbientacao: new UpdateAmbientacao(gateway),
    arquivarAmbientacao: new ArquivarAmbientacao(gateway),
  };

  return { useCases };
}
